import React from 'react';
import { Alert, Box, Button, CircularProgress, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import GridViewIcon from '@mui/icons-material/GridView';
import { useTranslation } from 'react-i18next';

/** Replaces the greeting row in edit mode. */
export default function EditToolbar({ isMobile, saving, saveError, onAdd, onPresets, onCancel, onSave }) {
  const { t } = useTranslation();
  return (
    <Box data-testid="dashboard-edit-toolbar" sx={{ mb: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mr: 'auto', minWidth: 0 }}>
          <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'rgba(49,130,206,0.10)', color: 'secondary.main', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <DashboardCustomizeIcon sx={{ fontSize: 20 }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 17, fontWeight: 700 }}>{t('dashboard.edit.customize')}</Typography>
            {!isMobile ? <Typography sx={{ fontSize: 12.5, color: 'text.secondary' }}>{t('dashboard.edit.hint')}</Typography> : null}
          </Box>
        </Box>
        {isMobile ? (
          <IconButton data-testid="dashboard-add-widget" aria-label={t('dashboard.edit.addWidget')} onClick={onAdd} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', width: 40, height: 40 }}>
            <AddIcon />
          </IconButton>
        ) : (
          <>
            <Button data-testid="dashboard-add-widget" variant="outlined" startIcon={<AddIcon />} onClick={onAdd} sx={{ borderRadius: '10px', borderColor: 'divider', color: 'text.primary' }}>
              {t('dashboard.edit.addWidget')}
            </Button>
            <Button data-testid="dashboard-presets" variant="outlined" startIcon={<GridViewIcon />} onClick={onPresets} sx={{ borderRadius: '10px', borderColor: 'divider', color: 'text.primary' }}>
              {t('dashboard.edit.presets')}
            </Button>
          </>
        )}
        <Button data-testid="dashboard-cancel" variant="text" onClick={onCancel} sx={{ color: 'text.secondary' }}>
          {t('dashboard.edit.cancel')}
        </Button>
        <Button
          data-testid="dashboard-save"
          variant="contained"
          color="secondary"
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <CheckIcon />}
          onClick={onSave}
          sx={{ borderRadius: '10px', boxShadow: '0 4px 12px rgba(49, 130, 206, 0.3)' }}
        >
          {t('dashboard.edit.save')}
        </Button>
      </Box>
      {saveError ? (
        <Alert severity="error" sx={{ mt: 1.5 }}>
          {t('dashboard.edit.saveFailed')}
        </Alert>
      ) : null}
    </Box>
  );
}
